/**
 * Insights_Service API client (task 21.2).
 *
 * | Method / Path                                          | Function          | Req. |
 * | ------------------------------------------------------ | ----------------- | ---- |
 * | `GET /accounts/{id}/insights?startDate=&endDate=`      | {@link getInsights} | R5.1 |
 *
 * An invalid range (missing/unparseable dates or end before start) surfaces as
 * an {@link ApiError} with code `INVALID_DATE_RANGE` (R5.8), rendered inline.
 */

import { apiGet } from './client.js';
import type { InsightsResult } from './types.js';

/**
 * Per-category spend totals for an account over `[startDate, endDate]` (dates
 * as `YYYY-MM-DD`, interpreted in SAST server-side). Totals exclude reversed
 * and reversing transactions and include an "Uncategorized" bucket, sorted by
 * total desc then name asc (R5.3–R5.5); an empty result is valid (R5.6).
 */
export function getInsights(
  accountId: string,
  startDate: string,
  endDate: string,
): Promise<InsightsResult> {
  return apiGet<InsightsResult>(
    `/accounts/${encodeURIComponent(accountId)}/insights`,
    { query: { startDate, endDate } },
  );
}
